import './style.css';
import { useEffect, useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import {
  HelpIcon,
  LoadingIndicator,
  useNotificationsStore
} from '@thermon-platforms/thermon-ui-core';
import useAlarmsStore from 'store/alarms';
import useDeviceTypesStore from 'store/device-types';
import useDevicesStore from 'store/devices';
import api from 'util/api';
import { getConfigItem } from 'util/device';


function General() {
  const [loading, setLoading] = useState(false);
  const [tempUnitSaving, setTempUnitSaving] = useState(false);
  const [overrideSaving, setOverrideSaving] = useState(false);
  const [showRange, setShowRange] = useState(false);
  const [site, setSite] = useState();
  const [, alarmsStoreActions] = useAlarmsStore();
  const [, deviceTypesStoreActions] = useDeviceTypesStore();
  const [devicesStore, devicesStoreActions] = useDevicesStore();
  const [, notificationsStoreActions] = useNotificationsStore();

  useEffect(() => {
    if (!devicesStore.devices.length) return;
    setLoading(true);
    devicesStoreActions.fetchDetail(devicesStore.devices.find(d => d.type == 'Site')?.id).then((detail) => {
      setSite(detail);
      setLoading(false);
    });
  }, [devicesStore]);

  function updateTmpUnit(event) {
    setTempUnitSaving(true);
    api(`/devices/${site.id}`, {
      method: 'PATCH',
      body: JSON.stringify({
        type: 'Site',
        configuration: [
          {
            key: 'TemperatureUnitDisplay',
            value: event.target.value
          }
        ]
      })
    })
    .then(() => {
      notificationsStoreActions.notify(t`Temperature units updated`, 'ok');
      // Update alarms and device types so they get the updated units
      alarmsStoreActions.query(true);
      deviceTypesStoreActions.query(true);
    })
    .finally(() => {
      setTempUnitSaving(false);
    });
  }

  function updateOverride(event) {
    setOverrideSaving(true);
    api(`/devices/${site.id}`, {
      method: 'PATCH',
      body: JSON.stringify({
        type: 'Site',
        configuration: [
          {
            key: 'AllowProgrammingErrorOverride',
            value: event.target.value
          }
        ]
      })
    })
    .then(() => {
      notificationsStoreActions.notify(t`Programming Error Override updated`, 'ok');
    })
    .finally(() => {
      setOverrideSaving(false);
    });
  }

  return (
    <div className="view general">
      <header>
        <h2><Trans>General Settings</Trans></h2>
      </header>
      <section>
        <ul className="form">
          {!site && loading ? <li><LoadingIndicator show={true} /></li> : null}
          {site ? <>
            <li>
              <label>
                <Trans>Temperature Units</Trans>
                <HelpIcon text={t`Select the temperature unit for display across Thermon Egis`} />
              </label>
              <select
                onChange={updateTmpUnit}
                disabled={loading || tempUnitSaving}
                defaultValue={getConfigItem(site, 'TemperatureUnitDisplay')?.value}
              >
                <option value="degC">°C</option>
                <option value="degF">°F</option>
                <option value="None"><Trans>None</Trans></option>
              </select>
              &nbsp;<LoadingIndicator show={tempUnitSaving} />
            </li>
            <li>
              <label>
                <Trans>Allow Programming Error Override</Trans>
                <HelpIcon text={t`Allow certain programming safeguards to be bypassed`} />
              </label>
              <select
                onChange={updateOverride}
                disabled={loading || overrideSaving}
                defaultValue={getConfigItem(site, 'AllowProgrammingErrorOverride')?.value}
              >
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
              &nbsp;<LoadingIndicator show={overrideSaving} />
            </li>
          </>: null}
          {/* <li>
            <label>
              <Trans>Data Retention</Trans>
              <HelpIcon text={t`Setting a data retention policy can help with privacy or data storage concerns`} />
            </label>
            <div className="input-group">
              <label>
                <input type="checkbox" onClick={e => setShowRange(e.target.checked)} />
                {!showRange ?
                  <Trans>Delete data after a certain timeframe</Trans> :
                  <Trans>Delete data older than:</Trans>
                }
              </label>
            </div>
            <div className="input-group">
              <input type="number" defaultValue={3} disabled={!showRange} />
              <select defaultValue="years" disabled={!showRange}>
                <option value="days"><Trans>Days</Trans></option>
                <option value="months"><Trans>Months</Trans></option>
                <option value="years"><Trans>Years</Trans></option>
              </select>
            </div>
          </li> */}
          {/* <li>
            <button>Update</button>
          </li> */}
        </ul>
      </section>
    </div>
  );
}

export default General;
